export function autoSuggestQuery(searchkey) {
  const query = {
    _source: ["topic_title"],
    query: {
      prefix: {
        "topic_title.keyword": searchkey,
      },
    },
    sort: {
      "topic_title.keyword": {
        order: "asc",
      },
    },
    size: 7,
  };

  return query;
}

export function searchTopicUrlQuery(searchKey, genus, from) {
  const query = {
    query: {
      bool: {
        must: [
          {
            bool: {
              should: [
                { match: { topic_content: searchKey } },
                { match: { topic_title: searchKey } },
              ],
            },
          },
          { match: { genus: genus } },
        ],
      },
    },
    highlight: {
      fields: {
        topic_content: {
          type: "fvh",
          fragment_size: 150,
          number_of_fragments: 3,
        },
        topic_title: {
          type: "fvh",
          number_of_fragments: 1,
        },
      },
    },
    size: 10,
    from: from,
  };
  return query;
}

export function searchWithTopicIdQuery(topicIds) {
  const query = {
    query: {
      terms: {
        topic_id: topicIds,
      },
    },
  };
  return query;
}
